
import { Component, Vue, Watch } from 'vue-property-decorator';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ActionConfirmation from '@/components/modals/ActionConfirmation.vue';
import TravelFilter from '@/components/filters/TravelFilter.vue';
import StatusFilter from '@/components/filters/StatusFilter.vue';
import AccomodationForm from '@/components/forms/AccomodationForm.vue';
import i18n from '@/plugins/i18n';
import Accomodation from '@/models/accommodation';
import AccomodationService from '@/services/AccomodationService';
import ApiHelper from '@/helpers/api-helper';
import { avisarBorrado, avisarGuardado, avisarPublicado } from '@/helpers/avisos';
import FormatHelper from '@/helpers/format-helper';
import CountryFilter from '@/components/filters/CountryFilter.vue';
import CityFilter from '@/components/filters/CityFilter.vue';

@Component({
	components: {
		CityFilter,
		CountryFilter,
		ActionConfirmation,
		TravelFilter,
		StatusFilter,
		DatePicker,
		AccomodationForm,
	},
})
export default class AccomodationTable extends Vue {
	@Watch('pagination')
	onPaginationChanged() {
		this.getList();
	}

	@Watch('filters.search')
	onSearchChanged(value: string) {
		if (!value || value.length === 0) {
			this.getList();
		} else if (value.length >= 3) {
			this.getList();
		}
	}

	$refs!: {
		actionConfirmation: InstanceType<typeof ActionConfirmation>;
	};

	private pagination: any;
	private filters: any;
	private lastFilters: any;
	private loading: boolean;
	private drawer: boolean;
	private edit_id: any;
	private accomodations: Accomodation[];
	private total: number;
	private aux_id: any;

	constructor() {
		super();
		this.pagination = {};
		this.filters = { country_id: null };
		this.lastFilters = {};
		this.filters.status_id = Accomodation.PUBLISHED.toString();
		this.loading = false;
		this.drawer = false;
		this.edit_id = null;
		this.accomodations = [];
		this.total = 0;
		this.aux_id = null;
	}

	private headers = [
		{ text: i18n.t('name'), value: 'name', align: 'start', sortable: true },
		{
			text: i18n.t('city_name'),
			value: 'city_name',
			align: 'start',
			sortable: true,
		},
		{
			text: i18n.t('creation_date'),
			value: 'created_at',
			align: 'start',
			sortable: true,
		},
		{
			text: i18n.t('published'),
			value: 'status_id',
			align: 'start',
			sortable: true,
		},
		{
			text: i18n.t('actions'),
			value: 'actions',
			align: 'end',
			sortable: false,
		},
	];

	/** N-291 (3A): la ficha se ha guardado (al crear y al editar). */
	alGuardarLaFicha() {
		avisarGuardado(this.$bus);
	}

	getList(force = false) {
		if (ApiHelper.filterHasChanged(this.pagination, this.filters, this.lastFilters) || force) {
			this.loading = true;
			AccomodationService.list(this.pagination, this.filters)
				.then(res => {
					if (res.status === 200) {
						this.accomodations = res.data.elements;
						this.total = res.data.total;
						this.loading = false;
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		}
	}

	onEdit(id) {
		this.edit_id = id;
		this.drawer = true;
		document.body.classList.add('drawer-open');
	}

	onNew() {
		this.edit_id = null;
		this.drawer = true;
		document.body.classList.add('drawer-open');
	}

	closeDrawer() {
		this.drawer = false;
		document.body.classList.remove('drawer-open');
	}

	onDelete(id) {
		this.aux_id = id;
		this.$refs['actionConfirmation'].show();
	}

	confirmDelete() {
		AccomodationService.delete(this.aux_id)
			.then(res => {
				if (res.status === 204) {
					this.aux_id = null;
					this.getList(true);
					this.$refs['actionConfirmation'].close();
					avisarBorrado(this.$bus);
				}
			})
			.catch(error => {
				// N-291: «Confirmar» se bloquea mientras trabaja; si falla, se libera.
				this.$refs['actionConfirmation'].release();
				if (error.response && error.response.status == 503) {
					this.$bus.$emit('error', { error: error, message: error.response.data });
				} else {
					ApiHelper.handleErrors(error, {}, this.$bus);
				}
			});
	}

	dateFormat(date) {
		return FormatHelper.formatDate(date);
	}

	changeStatus(item) {
		const component = this;
		AccomodationService.changeStatus(item)
			.then(res => {
				if (res.status === 200) {
					this.getList(true);
					avisarPublicado(this.$bus, item.status_id == 1);
				}
			})
			.catch(error => {
				// N-291 (3A): el interruptor ya se movió; si no se ha guardado, vuelve a su sitio.
				item.status_id = item.status_id == 1 ? 0 : 1;
				ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
			});
	}
}
